// extracted by mini-css-extract-plugin
export default {"list":"list_list__byU3-","item":"list_item__ws+60"};